export const codTipoMov = {
  ABERTURA: 23,
  FECHAMENTO: 24,
  REFORCO: 21,
  SANGRIA: 16,
  DINHEIRO: 16,
};
